/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R3_PurposeInputs */

const tr_cerez_s3_r3_purpose = /** @type {(inputs: Cerez_S3_R3_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seçtiğiniz görünüm (tema); yalnızca temayı değiştirdiğinizde yazılır (yerel depolama)`)
};

const en_cerez_s3_r3_purpose = /** @type {(inputs: Cerez_S3_R3_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The appearance (theme) you chose; written only when you change the theme (local storage)`)
};

const de_cerez_s3_r3_purpose = /** @type {(inputs: Cerez_S3_R3_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das von Ihnen gewählte Design; wird nur geschrieben, wenn Sie das Design ändern (lokaler Speicher)`)
};

const ru_cerez_s3_r3_purpose = /** @type {(inputs: Cerez_S3_R3_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбранное вами оформление (тема); записывается только при смене темы (локальное хранилище)`)
};

/**
* | output |
* | --- |
* | "The appearance (theme) you chose; written only when you change the theme (local storage)" |
*
* @param {Cerez_S3_R3_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r3_purpose = /** @type {((inputs?: Cerez_S3_R3_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R3_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r3_purpose(inputs)
	if (locale === "de") return de_cerez_s3_r3_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_r3_purpose(inputs)
	return tr_cerez_s3_r3_purpose(inputs)
});